module.exports = __webpack_public_path__ + "img/xiaotu1.588db183.png";